import React from 'react';
import { EditIcon, CalendarIcon, DollarSignIcon, Trash2Icon, UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export interface Payout {
  id: string;
  amount: number;
  date: string;
  customerId?: string;
  customerName?: string;
  notes?: string;
}
interface PayoutCardProps {
  payout: Payout;
  index: number;
  onEdit: (payout: Payout) => void;
  onDelete: (payout: Payout) => void;
  readOnly?: boolean;
}
export function PayoutCard({
  payout,
  index,
  onEdit,
  onDelete,
  readOnly = false
}: PayoutCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    delay: index * 0.05
  }} className="bg-white rounded-xl p-5 shadow-sm border border-stone-100 hover:shadow-md transition-shadow duration-200" data-id="element-913">
      <div className="flex items-start justify-between mb-3" data-id="element-914">
        <div className="flex-1" data-id="element-915">
          <div className="flex items-center gap-2 text-sm text-stone-500 mb-2" data-id="element-916">
            <CalendarIcon className="w-4 h-4 text-teal-600" data-id="element-917" />
            <span data-id="element-918">{new Date(payout.date).toLocaleDateString('da-DK')}</span>
          </div>
          {payout.customerName && <div className="flex items-center gap-2 text-sm text-stone-600 mb-2" data-id="element-919">
              <UserIcon className="w-4 h-4 text-blue-600" data-id="element-920" />
              <span className="font-medium" data-id="element-921">{payout.customerName}</span>
            </div>}
        </div>
        {!readOnly && <div className="flex items-center gap-1" data-id="element-922">
            <button onClick={() => onEdit(payout)} className="p-1.5 text-stone-400 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-all" aria-label="Rediger udbetaling" data-id="element-923">
              <EditIcon className="w-4 h-4" data-id="element-924" />
            </button>
            <button onClick={() => onDelete(payout)} className="p-1.5 text-stone-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all" aria-label="Slet udbetaling" data-id="element-925">
              <Trash2Icon className="w-4 h-4" data-id="element-926" />
            </button>
          </div>}
      </div>

      {payout.notes && <div className="text-sm text-stone-600 mb-4 line-clamp-2" dangerouslySetInnerHTML={{
      __html: payout.notes
    }} data-id="element-927" />}

      <div className="pt-4 border-t border-stone-100" data-id="element-928">
        <div className="flex items-center justify-between" data-id="element-929">
          <div className="flex items-center gap-2" data-id="element-930">
            <DollarSignIcon className="w-4 h-4 text-red-600" data-id="element-931" />
            <span className="text-sm text-stone-500" data-id="element-932">Beløb</span>
          </div>
          <span className="text-xl font-bold text-red-700" data-id="element-933">
            -{payout.amount.toLocaleString('da-DK')} kr
          </span>
        </div>
      </div>
    </motion.article>;
}